require('vendor/flatpickr')
